const bpList = {
	'(max-width: 1400px)': 'desktop',
	'(max-width: 1159px)': 'tablet',
	'(max-width: 759px)': 'phone-big',
	'(max-width: 360px)': 'phone',
	'(min-width: 1401px)': 'desktop-wide',
};

let current = '';

const bp = {
	previous: '',
	current: '',
	getRez: value => Object.keys(bpList).find(key => bpList[key] === value).match(/\d+/)[0]
};

function onResize() {
	
	for (let item in bpList) {
		if (window.matchMedia(item).matches) {
			current = bpList[item];
		}
	}
	
	if (bp.current !== current) {
		bp.previous = bp.current;
		bp.current = current;
		
		let event = new CustomEvent('bp-' + current);
		window.dispatchEvent(event);
		event = new CustomEvent('bpChanged');
		window.dispatchEvent(event);
	}
}

window.addEventListener('resize', onResize, false);
onResize();

module.exports = bp;
